import React, { useState } from "react";
import { CheckoutForm } from "../UI/Payment";

interface PaymentStepProps {
  onPaymentSuccess: () => void;
  onPaymentCancel: () => void;
}

export const PaymentStep: React.FC<PaymentStepProps> = ({
  onPaymentSuccess,
  onPaymentCancel,
}) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handlePaymentSuccess = () => {
    setIsProcessing(true);
    onPaymentSuccess();
  };

  const handlePaymentCancel = () => {
    onPaymentCancel();
  };

  return (
    <div className="form-step active">
      <h2 className="section-title">Payment</h2>

      <div className="text-center mb-8">
        <p className="text-gray-600 mb-6">
          Complete your payment to activate your professional profile and
          continue with the setup.
        </p>

        <div className="bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200 rounded-lg p-6 mb-6">
          <h3 className="text-xl font-semibold text-gray-900 mb-4">
            What's included in your professional profile:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
            <div className="space-y-2">
              <div className="flex items-center">
                <span className="text-green-500 mr-2">✓</span>
                <span className="text-gray-700">
                  Professional digital business card
                </span>
              </div>
              <div className="flex items-center">
                <span className="text-green-500 mr-2">✓</span>
                <span className="text-gray-700">QR code for easy sharing</span>
              </div>
              <div className="flex items-center">
                <span className="text-green-500 mr-2">✓</span>
                <span className="text-gray-700">
                  Custom branding and colors
                </span>
              </div>
            </div>
            <div className="space-y-2">
              <div className="flex items-center">
                <span className="text-green-500 mr-2">✓</span>
                <span className="text-gray-700">Social media integration</span>
              </div>
              <div className="flex items-center">
                <span className="text-green-500 mr-2">✓</span>
                <span className="text-gray-700">Mobile-responsive design</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-md mx-auto">
        <CheckoutForm
          onSuccess={handlePaymentSuccess}
          onCancel={handlePaymentCancel}
        />
      </div>

      {isProcessing && (
        <div className="text-center mt-6">
          <div className="inline-flex items-center px-4 py-2 bg-green-100 text-green-800 rounded-lg">
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-green-600"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            Processing payment...
          </div>
        </div>
      )}

      <div className="text-center mt-6">
        <button
          onClick={handlePaymentCancel}
          className="text-gray-500 hover:text-gray-700 text-sm underline"
        >
          Cancel and return to form
        </button>
      </div>
    </div>
  );
};
